import React from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { newFetch, POST } from '../../../../helpers/fetch';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';

const AssociateEvaluationForm = ({
  history,
  associate_id,
  site_id,
  restartFetchData,
}) => {
  const [evaluationDate, setEvaluationDate] = React.useState(
    moment().format('YYYY-MM-DD')
  );
  const [score, setScore] = React.useState(null);
  const [observation, setObservation] = React.useState('');

  const validateForm = () => {
    if (!evaluationDate) {
      ToastUtil.error('Evaluation Date cannot be empty.');
      return false;
    }

    if (!score) {
      ToastUtil.error('Score cannot be empty.');
      return false;
    }

    if (!observation) {
      ToastUtil.error('Observation cannot be empty.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this Evaluation?'
      ))
    ) {
      let api_path = `/performance_management/add-evaluation`;
      let response = await newFetch(POST, api_path, {
        associate_id,
        site_id,
        evaluation_date: evaluationDate,
        score,
        observation,
      });

      ToastUtil.success(response.message);

      if (response.success) {
        setEvaluationDate(null);
        setScore(null);
        setObservation('');
        restartFetchData();
      }
    }
  };

  return (
    <form className="form" onSubmit={(e) => handleSubmit(e)}>
      <Row className="mt-5">
        <Col>
          <label className="fw-bold text-muted">Date of Evaluation</label>
          <input
            type="date"
            className="form-control mt-1 adjust-fs w-25"
            value={evaluationDate || moment().format('YYYY-MM-DD')}
            onChange={({ target: { value } }) => setEvaluationDate(value)}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <label className="fw-bold text-muted">Score</label>
          <input
            type="number"
            className="form-control mt-1 adjust-fs w-25"
            value={score || 0}
            onChange={({ target: { value } }) => setScore(value)}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <label className="fw-bold text-muted">Observation</label>
          <textarea
            rows="5"
            className="form-control mt-3 adjust-fs"
            style={{ resize: 'none' }}
            value={observation}
            onChange={({ target: { value } }) => setObservation(value)}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="d-flex">
          <button
            type="submit"
            className="btn btn-brand adjust-fs adjust-shadow ms-auto"
            style={{ width: '10rem' }}
          >
            Save
          </button>
        </Col>
      </Row>
    </form>
  );
};

export default AssociateEvaluationForm;
